<template>
    <span>
        <button class="nav-item dropdown-item btn-link"
                @click="viewItem()">
            <slot name="modal-link"></slot>
        </button>
        <modal :show.sync="modals.classic" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">COUNTRY SUMMARY</h4>
            <hr />
            <div class="container">
                <label>Fiscal Year:</label>
                <base-input>
                    <v-select v-model="year" name="FiscalYear" :error="getError('FiscalYear')" :reduce="item => item.id" label="label" :options="fiscalYears" placeholder="Select" />
                </base-input>
            </div>
            <template slot="footer">
                <div class="container alert_footer">
                    <base-button type="danger"
                                 class="alert_footer_button btn_extra_small btn_info mr-4"
                                 @click.native="modals.classic = false">
                        Close
                    </base-button>
                    <base-button type="primary"
                                 class="alert_footer_button btn_extra_small btn_info"
                                 @click.native="submit">
                        Submit
                    </base-button>
                </div>
            </template>
        </modal>
    </span>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { BaseButton, Modal } from "@/components";
    import axios from "@/axios";
    import Utility from "@/mixins/utility/utility";
    import swal from "sweetalert2";
    import Util from "@/util/util";

    export default {
        name: "country-summary-modal",
        mixins: [Utility],
        props: {
        },
        data() {
            return {
                year: 0,
                modals: {
                    classic: false,
                },
            };
        },
        components: {
            Modal,
            BaseButton,
        },
        computed: {
            ...mapGetters({
                fiscalYears: "fiscalYears/fiscalYears",
            }),
        },
        methods: {
            ...mapActions({
                getFiscalYears: "fiscalYears/getFiscalYears",
            }),
            viewItem() {
                let ctx = this;
                ctx.getFiscalYears().then(() => {
                    ctx.modals.classic = true;
                });
            },
            async submit(e) {
                this.excelLoadTime += 1;
                let ctx = this;
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        ctx.generateReport(`/api/acsareports/countrysummary/${ctx.year}`, `Country_Summary_${ctx.year}.xlsx`).then(() => {
                            ctx.modals.classic = false;
                            ctx.excelLoadTime = 0
                        });
                    }
                });

                await new Promise(r => setTimeout(r,2000));
                    if (this.excelLoadTime != 0) {
                        this.showLoadingSweetAlert('Your Excel document is loading.<br><br>This message will disappear automatically in 10 seconds.')
                    }

                    while (this.excelLoadTime != 0) {
                        await new Promise(r => setTimeout(r, 10000));
                        if (this.excelLoadTime != 0) {
                            this.showLoadingSweetAlert('Please hang tight.  Your Excel document is <i>still loading</i>.<br><br><b>Note: <br>Depending on how many orders you export, it could take anywhere from a few seconds to over 5 minutes.')
                        }
                    }
            },
            showLoadingSweetAlert(message) {
                new swal({
                    position: 'top-end',
                    icon: 'warning',
                    title: 'Please Wait Patiently',
                    html: message,
                    timer: 10000,
                    showConfirmButton: false
                })
            },
            generateReport(url, title) {
                let ctx = this;
                return axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                })
                    .then((response) => {
                        Util.fileDownload(response.data, title);
                    });
            },
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
        },
    };
</script>
